<template>
  <div>
    <main>
      <v-container grid-list-xl class="content-header">
          <v-flex xs12 sm10 offset-sm1>
            <v-layout row wrap justify-space-between class="vertical-align">
              <v-flex xs4 sm3 class="text-xs-left">
                <h3 class="headline mb-0">Settings</h3>
              </v-flex>
              <v-flex xs8 sm9 class="text-xs-right">
                <a
                  v-if="$route.name === 'users'"
                  class="black--text"
                  @click.prevent="dialogNewUser = true">
                  <v-btn fab dark small color="primary">
                    <v-icon dark>add</v-icon>
                  </v-btn>
                  New User
                </a>
                <a
                  v-if="$route.name === 'events'"
                  class="black--text"
                  @click="dialogNewEvent = true">
                  <v-btn fab dark small color="primary">
                    <v-icon dark>add</v-icon>
                  </v-btn>
                  New Event
                </a>
                <router-link
                  v-if="isAllowed(2)"
                  :to="{ name: 'suitesList' }"
                  class="black--text"
                >
                  <v-btn fab dark small color="primary">
                    <v-icon dark>airline_seat_individual_suite</v-icon>
                  </v-btn>
                  Suite Manager
                </router-link>
                <router-link
                  v-if="isAllowed(2)"
                  :to="{ name: 'tvManager' }"
                  class="black--text"
                >
                  <v-btn fab dark small color="primary">
                    <v-icon dark>tv</v-icon>
                  </v-btn>
                  TV Manager
                </router-link>
              </v-flex>
            </v-layout>
            <v-flex md12 lg10 class="center">
              <v-card class="card--flex-toolbar mt-3">
                <v-layout row wrap color="primary" class="layout-adjustment">
                    <router-link 
                      flat tag="v-btn"
                      active-class="active" 
                      v-for="(tab, index) in tabs" 
                      v-if="!(index === 1 && !isAllowed(1))"
                      :key="index" :to="tab.path"                      
                      class="custom-btn"
                      >{{tab.title}}
                      </router-link>
                </v-layout>
                <v-divider></v-divider>
                <router-view></router-view>
              </v-card>
            </v-flex>
          </v-flex>
      </v-container>
    </main>
  <v-dialog v-model="dialogNewUser" max-width="500px">
      <create-new-user v-if="dialogNewUser" @close="dialogNewUser = false"></create-new-user>
    </v-dialog>

    <v-dialog v-model="dialogNewEvent" persistent max-width="500px">
      <create-new-event v-if="dialogNewEvent" @close="dialogNewEvent = false"></create-new-event>
    </v-dialog>
  </div>
</template>

<script>
  import NewUser from '../modals/User';
  import NewEvent from '../modals/Event';
  import auth from '../../auth/index';

  export default {
    data: () => ({
      tabs: [
        {
          title: 'Events',
          path: { name: 'events' },
        },
        {
          title: 'Users',
          path: { name: 'users' },
        },
        {
          title: 'Logs',
          path: { name: 'logs' },
        },
      ],
      dialogNewUser: false,
      dialogNewEvent: false,
      isAllowed: auth.isAllowed,
    }),
    components: {
      createNewUser: NewUser,
      createNewEvent: NewEvent,
    },
  };
</script>


<style scoped lang="scss">
  main {
    padding-top: 64px;
  }
  .center {
    margin: 0 auto;
  }
  .layout-adjustment {
    margin: 0 !important;
    padding: 0 !important;
  }
  .custom-btn {
    justify-content: space-between;
    width: 33.32%;
    margin: 0 !important;
    height: 48px;

    &.active{
      background-color: #00838f !important;
      color: #fff !important;
      &::before {
        border-radius: inherit;
        color: inherit;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        opacity: 0.12;
        transition: .3s cubic-bezier(.25,.8,.5,1);
        width: 100%;
        background-color: #00838f;
      }
    }
  }
  @media only screen and (max-width: 600px) {
    .headline {
      font-size: 15px !important;
    }
    .vertical-align {
      align-items: flex-start !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/eventManager/Index.vue